import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import App from "./App.vue";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/ja";

import * as Rx from 'rxjs';
import vueRx from 'vue-rx';

import store from "@/store";
import router from "@/router";
import VTooltip from 'v-tooltip';

Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(ElementUI, { locale });
Vue.use(Vuex);
Vue.use(vueRx, Rx);
Vue.use(VTooltip);


const app = new Vue({
  data: { loading: false },
  router,
  store,
  render: h => h(App)
}).$mount("#app");

router.beforeEach((to: any, from: any, next: any) => {
  app.loading = true;
  next();
});

router.afterEach((to: any, from: any) => {
  setTimeout(() => app.loading = false, 0); // timeout for demo purposes
});

